import I18n from "../../I18n";
import { datetime } from "../../utils";
import { stringifyFilter } from "colbi_web_ui/lib/utils";

const mapCard = (json) => {
    const { id, name, status, uploadedAt, submittedBy, type } = json;

    return [
        [
            {
                labels: ["id"],
                value: id,
                type: "string",
                align: "left",
                basis: "20%",
            },
        ],
        [{ labels: ["name"], value: name, type: "string", align: "left" }],
        [
            {
                labels: ["uploaded"],
                value: datetime(uploadedAt),
                type: "datetime",
                align: "center",
            },
        ],
        [{ labels: ["user"], value: submittedBy, type: "string", align: "left" }],
        [{ labels: ["fileType"], value: type, type: "string", align: "left" }],
        [
            {
                labels: ["status"],
                value: [status, I18n.translate`${status}`],
                type: "dataFileStatus",
            },
        ],
        [{ labels: [], value: ["delete"], type: "user_actions" }],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        id: json.id,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/invalid_files/status/${
                json.type
            }/${json.id}?filter=${stringifyFilter([
                { column: "ID", filters: [{ value: `${json.id}` }] },
            ])}`,
        },
    };
};

const header = [
    { label: ["Id"], align: "left", basis: "20%" },
    { label: ["Name"], align: "left", columnName: "name", sortable: true },
    {
        label: ["Uploaded at"],
        align: "center",
        columnName: "uploaded_at",
        sortable: true,
    },
    { label: ["Uploaded by"], align: "left" },
    { label: ["Type"], align: "left", columnName: "type" },
    { label: ["Status"], align: "center" },
    { label: ["checkbox"], align: "right" },
];

const invaliddatafileMapper = {
    map: mapper,
    header,
};

export default invaliddatafileMapper;
